import { DerivedAvailabilityStatusInternal } from '@commerce-product-webcomponents/sdk';
import { BundlePropType } from './CartCardComponent';
import { UpdateAvailabilityStatusAndDate } from './types/propsTypes';

export const isPartialBackOrderCondition = (
  bundle?: BundlePropType[],
  firstAvailableFutureDate = '',
  derivedAvailabilityStatus = '',
): { derivedAvailabilityStatus: string; farthestDateAvailable: string } => {
  const isStatusBo = (status?: string) => status === DerivedAvailabilityStatusInternal.Bo;
  let farthestDateAvailable = firstAvailableFutureDate;
  let isPbo = false;
  if (bundle && bundle?.length > 0 && isStatusBo(derivedAvailabilityStatus)) {
    const childProductStatusAndDate: UpdateAvailabilityStatusAndDate[] = bundle.reduce(
      (acc: UpdateAvailabilityStatusAndDate[], curr: BundlePropType) => {
        if (isStatusBo(curr.derivedAvailablityStatus)) {
          acc.push({
            derivedAvailabilityStatus: curr.derivedAvailablityStatus || '',
            firstAvailableFutureDate: curr.firstAvailableFutureDate || '',
          });
        }
        return acc;
      },
      [],
    );
    isPbo = bundle.length > childProductStatusAndDate.length;
    farthestDateAvailable = [...childProductStatusAndDate]?.sort(
      (a, b) => new Date(b?.firstAvailableFutureDate).getTime() - new Date(a?.firstAvailableFutureDate).getTime(),
    )?.[0]?.firstAvailableFutureDate;
  }
  return {
    derivedAvailabilityStatus: isPbo ? DerivedAvailabilityStatusInternal.Pbo : derivedAvailabilityStatus,
    farthestDateAvailable,
  };
};
